// This import _is_ necessary
import { h } from 'preact';
import { AnswerFactory } from './answers';
import { ANSWER_STATUS } from 'constants/annotations';
import { ProportionalImage } from 'rendering/components/proportional_image';

export const Question = ({
    id = '',
    displayed = false,
    answers = [],
    content = '',
    description = '',
    styles = {},
    properties = {},
    disabled = false,
    defaultValue,
    thumbnail,
    answered,
    selectedAnswer,
    showingCorrect
}) => {
    const { questionType } = properties;
    const style = styles.answer || {};
    const rootAttrs = {
        disabled,
        className: 'quiz-question',
        'data-active': displayed,
        style: {
            display: displayed ? 'block' : 'none'
        }
    };
    const questionDivider = { borderColor: 'gray' };
    
    if (answered !== ANSWER_STATUS.NOT_ANSWERED) {
        rootAttrs['data-correct'] = 
            answered === ANSWER_STATUS.ANSWERED_CORRECTLY ?
                'true' :
                'false'
    }

    if (styles.title) {
        questionDivider.borderColor = styles.title.color;
    }

    return (
        <div tabIndex="0" className="quiz-question-scroll-container">
            <fieldset {...rootAttrs}>
                <legend className="question-details" data-has-thumbnail={thumbnail ? 'true' : 'false'} style={questionDivider}>
                    {thumbnail && <ProportionalImage className="thumbnail" src={thumbnail} content={content} />}
                    <p className="question-title" style={styles.title}>{content}</p>
                    <p className="question-description" style={styles.description}>{description}</p>
                </legend>
                {
                    AnswerFactory.getAnswer({
                        defaultValue,
                        questionType,
                        questionId: id,
                        showingCorrect,
                        selectedAnswer,
                        answers,
                        id, 
                        style
                    })
                }
            </fieldset>
        </div>
    )
}